module.exports = __webpack_public_path__ + "img/clients2-1023.b2fa632.png";